import { LinkToEduIntervalNotesQuizPage } from "../../constants/navUrlConstants";
import ButtonCard from "../generic/ButtonCard";
import CardContainer from "../generic/CardContainer";

interface Props {}

function EduPage(props: Props) {
  const handleSelect = (buttonKey: string) => {
    window.location.hash = buttonKey;
  };

  return (
    <CardContainer>
      <ButtonCard buttonKey={LinkToEduIntervalNotesQuizPage} onSelect={handleSelect}>
        Practice quick recall of the intervals between notes
      </ButtonCard>
    </CardContainer>
  );
}

export default EduPage;
